let tips = {
  /**
   * @description 工程中的提示语配置文件
   */
  uploadLogoTip: "建议使用40*40，1M以内，jpg、png图片", // app注册和修改上传logo的提示语
  uploadTypeErrorTip: "上传logo图片只能是 JPG 格式或PNG格式!", // app注册和修改上传logo的格式错误提示语
  uploadBigErrorTip: "上传logo图片大小不能超过 1MB!", // app注册和修改上传logo大小错误的提示语
  regSuccessTip: "注册成功", // app注册成功提示语
  lookupTip:
    "适用组织不可再将该应用授权给新的单位使用，已经授权和启用该应用的单位不受影响", // 应用确认停用提示
  lookupmangageTip: "应用停用后，授权给的单位下任何成员都无法再访问该应用", // 应用管理停用提示
  copySecretSuccessTip: "复制成功", // 复制Secret成功提示语
  openupEditSuccessTip: "修改成功", // 开放平台接口应用编辑成功提示语
  openupRegSuccessTip: "注册成功", // 开放平台接口应用编辑成功提示语
  empowerSuccessTip: "授权成功", // 权限管理
  deleteSuccessTip: "删除成功", // 删除成功
  insertSuccessTip: "添加成功", // 新增成功
  addprocessSuccessTip: "新建成功", // 新建流程成功提示语
  dontSupplierTip: "您没有选择任何记录", // 没有选择分包商提示语
  dontPurchaserTip: "您没有选择任何记录", // 没有选择分包商提示语
  deleteRoleTip:
    "角色被删除时，该角色下的成员所对应的的权限将全部取消。您是否确定删除？" // 删除角色前提醒提示
};
export default tips;
